// offer pop up JS  ( "sessionstorage" )
$(document).ready(function() {
  if($.trim($("#custom-offer-popup").html()) != '') { 
    var popupShown = localStorage.getItem('popupShown'); // Use localStorage instead of sessionStorage

    if (!popupShown) {
      
      setTimeout(function() {
        $.magnificPopup.open({
          items: {
            src: '#custom-offer-popup',
            type: 'inline'
          },
          closeBtnInside: true,
          callbacks: {
            open: function() {
              setTimeout(function() {
                $('#custom-offer-popup .popup-wrap').addClass('show');
              }, 10);
            },
            close: function() {
              $('#custom-offer-popup .popup-wrap').removeClass('show');
            }
          }
        });
      }, 3000); // 3 Seconds

      // Set localStorage so that the popup doesn't show again
      localStorage.setItem('popupShown', 'true');
    }
  }
});
// offer pop up JS  ( "sessionstorage" )

// meta object click on image video will play on blog page 
    document.addEventListener("DOMContentLoaded", function () {
      var thumbnail = document.getElementById("recipe-thumbnail");
      var playButton = document.getElementById("recipe-play-button");
      var video = document.getElementById("recipe-video");

      function playVideo() {
        thumbnail.style.display = "none";
        playButton.style.display = "none";
        video.style.display = "block";
        video.play();
      }

      thumbnail.addEventListener("click", playVideo);
      playButton.addEventListener("click", playVideo);
    });
// meta object click on image video will play on blog page end

